// src/pages/AccessDenied/AccessDeniedPage.jsx
import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";

const AccessDeniedPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const attemptedRoute = location.state?.from || "";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "grey.100",
        p: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 450,
          textAlign: "center",
        }}
      >
        <BlockOutlinedIcon
          sx={{ fontSize: 80, color: "error.main", mb: 2 }}
        />

        <Typography variant="h4" gutterBottom>
          Access Denied
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Your role does not have permission to access this module.
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Please contact the system administrator.
        </Typography>

        {attemptedRoute && (
          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            sx={{ mb: 3 }}
          >
            Requested route: <strong>{attemptedRoute}</strong>
          </Typography>
        )}

        <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
          <Button variant="contained" onClick={() => navigate("/Main")}>
            Go to Dashboard
          </Button>
          <Button variant="outlined" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default AccessDeniedPage;
